module.exports = __webpack_public_path__ + "public/images/dance.0a86bc6d44404047d48bc1345529c4fa.png";